//Local
// export const API_HOST = "http://localhost:8000/"
// export const MAIN_HOST = 'http://localhost:8000/'
// export const API_EXPORT = "http://localhost:8000/"
// export const IMG_HOST       = "http://localhost/api_presensi_new/public/media/"
// export const DEFAULT_IMG    = MAIN_HOST+'media/image/default-img.png'

// export const BACKEND_API_HOST = "http://localhost:8000/backend/"

// Development
// export const API_HOST = "https://servicesdev.presensi.co.id/"
// export const MAIN_HOST = "https://servicesdev.presensi.co.id/"
// export const IMG_HOST       = "https://servicesdev.presensi.co.id/media/"
// export const DEFAULT_IMG    = MAIN_HOST + 'media/logo-default-user.png'
// export const MESSAGE_COMPANY_ID = "6833df2839fd9718c77ef27a"
// export const MESSAGE_HOST       = "https://message-dev.belanjatech.com/api/v1";
// export const MESSAGE_WEB_SOCKET = "wss://message-dev.belanjatech.com/api/v1";
// export const IMG_MESSAGE_HOST   = "https://s3.belanjatech.com/media/"

// Production
export const API_HOST       = "https://services.presensi.co.id/"
export const MAIN_HOST      = 'https://services.presensi.co.id/'
export const API_EXPORT     = "https://services.presensi.co.id/"
export const IMG_HOST       = "https://services.presensi.co.id/media/"
export const DEFAULT_IMG    = MAIN_HOST+'media/image/default-img.png'
export const MESSAGE_COMPANY_ID = "688c38fee2e892bfe1ae9e3d"
export const MESSAGE_HOST       = "https://messages.belanjatech.com/api/v1";
export const MESSAGE_WEB_SOCKET = "wss://messages.belanjatech.com/api/v1";
export const IMG_MESSAGE_HOST   = "https://s3.belanjatech.com/media/"
export const THUMB_HOST     = MAIN_HOST+'media/image/thumb/'

export const MITRA_HOST     = "https://mitra.presensi.co.id"
